// File: stacks/workout/app/src/config/timers.js

// Centralized timer presets with descriptions and default settings.
//
// Terminology:
//   rounds  – work+rest intervals within a single set
//   sets    – how many times to repeat the full round block
//   rest    – rest between rounds (within a set)
//   setRest – rest between sets
export const TIMER_PRESETS = {
  hiit: {
    label: "HIIT",
    macroLabel: "HIIT",
    macroTitle: "HIIT rounds",
    description:
      "High-Intensity Interval Training. Short bursts of intense work followed by brief rest.",
    settings: { work: 45, rest: 15, rounds: 8, sets: 1, setRest: 60 },
  },
  tabata: {
    label: "Tabata",
    macroLabel: "Tabata",
    macroTitle: "Tabata rounds",
    description:
      "A specific HIIT format: 20 seconds of all-out effort, 10 seconds of rest, repeated 8 times.",
    settings: { work: 20, rest: 10, rounds: 8, sets: 4, setRest: 45 },
  },
  emom: {
    label: "EMOM",
    macroLabel: "EMOM",
    macroTitle: "EMOM intervals",
    description:
      "Every Minute on the Minute. Perform a set number of reps at the start of each minute.",
    settings: { duration: 60, rounds: 10, sets: 1, setRest: 60 },
  },
  fgb: {
    label: "Fight Gone Bad",
    description:
      "5 stations of 1 minute each, followed by 1 minute of rest. A highly standardised fitness test.",
    settings: {
      exerciseTime: 60,
      restTime: 0,
      exercises: 5,
      rounds: 3,
      setRest: 60,
    },
  },
  amrap: {
    label: "AMRAP",
    description:
      "As Many Rounds/Reps As Possible within a set time. A test of work capacity.",
    settings: { duration: 600, sets: 1, setRest: 60 }, // 10 minutes
  },
  forTime: {
    label: "For Time",
    description:
      "Complete a set amount of work as fast as possible. A simple stopwatch.",
    settings: { hasTarget: true },
  },
  circuit: {
    label: "Circuit",
    macroLabel: "Circuit",
    macroTitle: "Circuit rounds",
    description:
      "Move from one exercise to the next with minimal rest. Good for endurance and efficiency.",
    settings: { exerciseTime: 40, restTime: 20, rounds: 3, exercises: 6 },
  },
  free: {
    label: "Free training",
    description:
      "Your plan or none. Start the clock, log each set as you go, and it's saved as your session. Heart rate and equipment connect as usual.",
    settings: {},
  },
  stopwatch: {
    label: "Stopwatch",
    description:
      "A basic timer that counts up. Ideal for tracking total workout time or specific tasks.",
    settings: {},
  },
  countdown: {
    label: "Countdown",
    description: "A basic timer that counts down from a set duration.",
    settings: { duration: 300, sets: 1, setRest: 60 }, // 5 minutes
  },
};

export const getTimerMacroLabels = (mode) => {
  const preset = TIMER_PRESETS[mode] || {};
  const baseLabel = preset.label || mode || "Round";

  return {
    groupLabel: preset.macroLabel || baseLabel,
    title: preset.macroTitle || `${baseLabel} rounds`,
  };
};
